import axios from '../axios'


export const testConnection = (data) => {
  return axios({
    url: '/generate/testConnection',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
export const getTables = (data) => {
  return axios({
    url: '/generate/getTables',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
export const getGenerateModel = (data) => {
  return axios({
    url: '/generate/getGenerateModel',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
export const generateModels = (data) => {
  return axios({
    url: '/generate/generateModels',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/generate.js